// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1___edfbd276d5eda78dc28","cls2":"Comments-cls2___b500547c0c96f1df89c Comments-cls1___edfbd276d5eda78dc28"};